export default "__VITE_ASSET__BRly5wLe__"